module.exports = __webpack_public_path__ + "img/sidenav-button-logout.0204ee2a.svg";